import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';

import { SelectModule } from 'primeng/select';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { CardModule } from 'primeng/card';
import {
  ProgressSpinner,
  ProgressSpinnerModule,
} from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';
import { ToastModule } from 'primeng/toast';
import { GalleriaModule } from 'primeng/galleria';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { CheckboxModule } from 'primeng/checkbox';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { StepperModule } from 'primeng/stepper';
import { InputNumberModule } from 'primeng/inputnumber';
import { PasswordModule } from 'primeng/password';
import { PanelModule } from 'primeng/panel';
import { AvatarModule } from 'primeng/avatar';
import { TreeSelectModule } from 'primeng/treeselect';
import { ListboxModule } from 'primeng/listbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { RatingModule } from 'primeng/rating';
import { FileUploadModule } from 'primeng/fileupload';
import { ToolbarModule } from 'primeng/toolbar';
import { MenuModule } from 'primeng/menu';
import { BlockUIModule } from 'primeng/blockui';
import { RippleModule } from 'primeng/ripple';
import { MatStepperModule } from '@angular/material/stepper';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ProgressBarModule } from 'primeng/progressbar';
import { BadgeModule } from 'primeng/badge';
import { TreeTableModule } from 'primeng/treetable';
import { ChartModule } from 'primeng/chart';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SelectModule,
    ScrollPanelModule,
    PanelMenuModule,
    ButtonModule,
    TableModule,
    MultiSelectModule,
    CardModule,
    DialogModule,
    DatePickerModule,
    ToastModule,
    GalleriaModule,
    InputTextModule,
    MessageModule,
    CheckboxModule,
    ToggleSwitchModule,
    StepperModule,
    InputNumberModule,
    PanelModule,
    PasswordModule,
    AvatarModule,
    TreeSelectModule,
    ListboxModule,
    ConfirmDialogModule,
    TagModule,
    RatingModule,
    FileUploadModule,
    ToolbarModule,
    MenuModule,
    BlockUIModule,
    RippleModule,
    MatStepperModule,
    RadioButtonModule,
    FloatLabelModule,
    TabsModule,
    TextareaModule,
    IconFieldModule,
    InputIconModule,
    PopoverModule,
    DrawerModule,
    AutoCompleteModule,
    ProgressSpinner,
    ProgressSpinnerModule,
    ToggleButtonModule,
    TooltipModule,
    ProgressBarModule,
    BadgeModule,
    TreeTableModule,
    ChartModule,
  ],

  exports: [
    SelectModule,
    ScrollPanelModule,
    PanelMenuModule,
    ButtonModule,
    TableModule,
    MultiSelectModule,
    CardModule,
    DialogModule,
    DatePickerModule,
    ToastModule,
    GalleriaModule,
    RadioButtonModule,
    InputTextModule,
    MessageModule,
    CheckboxModule,
    ToggleSwitchModule,
    StepperModule,
    InputNumberModule,
    PanelModule,
    PasswordModule,
    AvatarModule,
    TreeSelectModule,
    ListboxModule,
    ConfirmDialogModule,
    TagModule,
    RatingModule,
    FileUploadModule,
    ToolbarModule,
    MenuModule,
    BlockUIModule,
    RippleModule,
    MatStepperModule,
    FloatLabelModule,
    TabsModule,
    TextareaModule,
    IconFieldModule,
    InputIconModule,
    PopoverModule,
    DrawerModule,
    AutoCompleteModule,
    ProgressSpinner,
    ProgressSpinnerModule,
    SelectModule,
    InputNumberModule,
    DatePickerModule,
    TooltipModule,
    ProgressBarModule,
    BadgeModule,
    ToggleSwitchModule,
    TreeTableModule,
    ChartModule,
  ],
})
export class SharedPrimengModule {}
